export default __webpack_public_path__ + "static/media/icons-gpa-7.86531939.png";